const headerEl = document.querySelector(".header");
const breadcrumbEl = document.querySelector(".breadcrumb");
const overlayEl = document.getElementById("overlay");

function removeHeader() {
  if (headerEl) headerEl.style.display = "none";
  if (breadcrumbEl) breadcrumbEl.style.opacity = 0;
}

function addHeader() {
  if (headerEl) headerEl.style.display = "block";
  if (breadcrumbEl) breadcrumbEl.style.opacity = 1;
}

function openModal(modal) {
  if (!modal) return;
  modal.style.display = "block";
  overlayEl.style.display = "block";
  document.body.style.overflow = "hidden";
  removeHeader();
}

function closeModal(modal) {
  if (!modal) return;
  modal.style.display = "none";
  overlayEl.style.display = "none";
  document.body.style.overflow = "auto";
  addHeader();
}

const modalSnap = document.getElementById("myModalSnap");
const modalAcima = document.getElementById("myModalAcima");
const modalProgressive = document.getElementById("myModalProgressive");

const snapClose = document.querySelector(".secondClose");
const acimaClose = document.querySelector(".acimaClose");
const progressiveClose = document.querySelector(".close");

const snapCardEl = document.querySelector(".cards-grid.section-template--20107142529306__a14537e4-0fbf-42f9-806a-52357c19fe71-padding .cards-grid__item:nth-child(5)");
const acimaCardEl = document.querySelector(".cards-grid.section-template--20107142529306__a14537e4-0fbf-42f9-806a-52357c19fe71-padding .cards-grid__item:nth-child(1)");
const progressiveCardEl = document.querySelector(".cards-grid.section-template--20107142529306__a14537e4-0fbf-42f9-806a-52357c19fe71-padding .cards-grid__item:nth-child(6)");

if (snapCardEl) {
  snapCardEl.addEventListener("click", function (e) {
    e.preventDefault();
    openModal(modalSnap);
  });
}

if (acimaCardEl) {
  acimaCardEl.addEventListener("click", function (e) {
    e.preventDefault();
    openModal(modalAcima);
  });
}

if (progressiveCardEl) {
  progressiveCardEl.addEventListener("click", function (e) {
    e.preventDefault();
    openModal(modalProgressive);
  });
}

if (snapClose) snapClose.onclick = () => closeModal(modalSnap);
if (acimaClose) acimaClose.onclick = () => closeModal(modalAcima);
if (progressiveClose) progressiveClose.onclick = () => closeModal(modalProgressive);

window.onclick = function (event) {
  if (event.target === modalSnap) closeModal(modalSnap);
  if (event.target === modalAcima) closeModal(modalAcima);
  if (event.target === modalProgressive) closeModal(modalProgressive);
};

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    if (modalProgressive && modalProgressive.style.display === "block") closeModal(modalProgressive);
    if (modalSnap && modalSnap.style.display === "block") closeModal(modalSnap);
    if (modalAcima && modalAcima.style.display === "block") closeModal(modalAcima);
  }
});